module.exports = __webpack_public_path__ + "media/images/redesign-images/textures/texture-1-af708deb35caec5d9da02a13c9f53c90.svg";